import { getJwtToken } from 'src/api/preferencesClient';

/**
 * Extract the username (Midway alias) from the stored JWT.
 * Returns null if no token is available or decoding fails.
 */
export function getUsernameFromJwt(): string | null {
  const token = getJwtToken();
  if (!token) return null;
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    return payload.identities?.[0]?.userId || payload.sub || null;
  } catch {
    return null;
  }
}
